<div mat-dialog-content>
    {{data.message}}
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
    <button mat-button (click)="onNoClick()">{{data.no}}</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.yes}}</button>
</div>
